import { Box, Drawer, useMediaQuery } from "@mui/material";
import { useState } from "react";
import FilterWrapper from "./FilterWrapper";

export default function ResponsiveFilters({
  filter,
  searchTerm,
  recentSearches,
  handleCompanyChange,
  handleJobTypeChange,
  handleSalaryChange,
  handleLocationChange,
  handleExpChange,
  handleCityChange,
  handleSearch,
  handleClearSearch,
  handleClearAllFilters
}) {
  const [open, setOpen] = useState(false);
  const isDesktop = useMediaQuery("(min-width:900px)");

  const toggleDrawer = (state) => () => setOpen(state);

  return (
    <>
      {/* Permanent on desktop, drawer on mobile */}
      {isDesktop ? (
        <Box width={"100%"}>
          <FilterWrapper
            empType={filter.type}
            locType={filter.location}
            salary={filter.salary}
            exp={filter.exp}
            city={filter.city}
            searchTerm={searchTerm}
            company={filter.company}
            handleCompanyChange={handleCompanyChange}
            handleJobTypeChange={handleJobTypeChange}
            handleSalaryChange={handleSalaryChange}
            handleLocationChange={handleLocationChange}
            handleExpChange={handleExpChange}
            handleCityChange={handleCityChange}
            handleSearch={handleSearch}
            handleClearSearch={handleClearSearch}
            handleClearAllFilters={handleClearAllFilters}
          />
          {recentSearches}
        </Box>
      ) : (
        <Drawer anchor="right" open={open} onClose={toggleDrawer(false)}>
          <Box sx={{ width: 300, p: 2 }}>
            <FilterWrapper
              empType={filter.type}
              locType={filter.location}
              salary={filter.salary}
              exp={filter.exp}
              city={filter.city}
              searchTerm={searchTerm}
              company={filter.company}
              handleCompanyChange={handleCompanyChange}
              handleJobTypeChange={handleJobTypeChange}
              handleSalaryChange={handleSalaryChange}
              handleLocationChange={handleLocationChange}
              handleExpChange={handleExpChange}
              handleCityChange={handleCityChange}
              handleSearch={handleSearch}
              handleClearSearch={handleClearSearch}
              handleClearAllFilters={handleClearAllFilters}
            />
            {recentSearches}
          </Box>
        </Drawer>
      )}
    </>
  );
}
